import Image from 'next/image';
import Link from 'next/link';

import { transformImageUrl } from '@scripts/helpers';

import styles from './CategoryPanel.module.scss';

const CATEGORY_IMAGE_SIZE = 90;

const CategoryPanel = ({
    link,
    image,
    name,
    code,
}: {
    link: string;
    image: string | null;
    name: string;
    isBig?: boolean;
    code?: string;
}) => {
    return (
        <div className={styles.root}>
            <Link legacyBehavior href={link} prefetch={false} passHref>
                <a aria-label={name} className={styles.link}>
                    <div className={styles.imageWrap}>
                        {image && (
                            <Image
                                src={transformImageUrl(image, CATEGORY_IMAGE_SIZE, CATEGORY_IMAGE_SIZE)}
                                placeholder="empty"
                                alt={code || name}
                                fill
                                className={styles.image}
                            />
                        )}
                    </div>
                    <span className={styles.name}>{name}</span>
                </a>
            </Link>
        </div>
    );
};

export default CategoryPanel;
